/**
 * Функции в разработке (ADR-017): список включённых приходит из /api/config. Пока не пришёл — всё выключено,
 * чтобы скрытое не мелькало. Модули прототипа (документ, острова) читают FEAT при отрисовке.
 */
export const FEAT = { tasks: false, ai: false, agent: false, billing: false, sites: false };
export type FeatureKey = keyof typeof FEAT;

export function setFeatures(list: readonly string[] | undefined) {
  for (const k of Object.keys(FEAT) as FeatureKey[]) FEAT[k] = !!list?.includes(k);
}
